
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SidebarNavigation from './SidebarNavigation';
import ProfileDropdown from './ProfileDropdown';

type SidebarProps = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isOpen: boolean) => void;
  userName: string;
  userInitials: string;
  userTitle?: string;
  avatarUrl?: string | null;
  onSignOut: () => Promise<void>;
};

const Sidebar = ({ 
  isSidebarOpen, 
  setIsSidebarOpen, 
  userName, 
  userInitials,
  userTitle,
  avatarUrl,
  onSignOut 
}: SidebarProps) => {
  return (
    <aside
      className={`fixed md:sticky top-0 h-full md:h-screen w-64 bg-white shadow-lg transform transition-transform duration-200 ease-in-out z-30 ${
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
      }`}
    >
      <div className="flex flex-col h-full">
        <div className="p-4 hidden md:flex items-center mb-4">
          <img 
            src="/lovable-uploads/95822005-216a-471c-aa2e-8f186810d92f.png" 
            alt="Snabba upphandlingar.se" 
            className="h-20 w-auto"
          />
        </div>
        
        <div className="p-4 flex justify-between items-center md:hidden">
          <div className="flex items-center gap-2">
            <img 
              src="/lovable-uploads/95822005-216a-471c-aa2e-8f186810d92f.png" 
              alt="Logo" 
              className="h-12 w-auto"
            />
            <span className="font-bold">Snabbaupphandlingar</span>
          </div>
          <Button variant="ghost" size="icon" onClick={() => setIsSidebarOpen(false)}>
            <X size={24} />
          </Button>
        </div>
        
        <SidebarNavigation />
        
        <ProfileDropdown 
          userName={userName} 
          userInitials={userInitials}
          userTitle={userTitle}
          avatarUrl={avatarUrl}
          onSignOut={onSignOut} 
        />
      </div>
    </aside>
  );
};

export default Sidebar;
